import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class EmailColumn extends Column {
    title = 'payroll.settings.email';
    property = 'email';
    sortable = false;
    type: CellDisplay = CellDisplay.string;
}
